var demoFcIntegration = (function () {
  var submitBtn, demoFcModal;

  return {
    init: init,
  };

  function init() {
    uiBindings();
  }

  function uiBindings() {
    var demoFcCTA = document.querySelectorAll('.open-demo-fc-integration button');
    for (var i = 0; i < demoFcCTA.length; i++) {
      //click event
      demoFcCTA[i].addEventListener(
        'click',
        function (evt) {
          evt.preventDefault();
          var thatBtn = this,
            loaderIcon = thatBtn.querySelector('.btn-icon'),
            btnText = thatBtn.querySelector('.btn-text');

          //set submit button in cache
          submitBtn = document.querySelector('#tingle-modal-box .demo-fc__submit');

          //disable button and show loader
          thatBtn.setAttribute('disabled', 'disabled');
          loaderIcon.classList.remove('hide');
          btnText.classList.add('hide');

          //view Event
          WebEventTracker.logEvent(
            EDS.webEvents,
            'DemoExDemoCTAClicked',
            bsLib.extend(
              {
                action: 'view',
              },
              popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
            )
          );

          //login user check
          if (wpUserLoggedIn) {
            var urlLinkEnv = 'https://automate.browserstack.com';

            if (window.location.hostname !== 'www.browserstack.com') {
              urlLinkEnv = 'https://automate-k8s-devos.bsstag.com';
            }

            //freshchat file
            if (typeof window.fcWidget !== 'undefined') {
              window.fcWidget.destroy();
            }

            bsLib.ajax(
              'GET',
              urlLinkEnv + '/api/v1/user?product=wp',
              {},
              true,
              {},
              // Success
              function (data) {
                if (data.readyState === 4) {
                  var dataRequest = bsLib.JSONParse(data.response);
                  if (typeof dataRequest.success !== 'undefined' && dataRequest.success) {
                    var formCheckerCSF = document.querySelector('.demo-fc__heading');

                    //update name
                    formCheckerCSF.innerHTML = 'Hi ' + dataRequest.data.name + '! Talk to our product experts';
                    var check_email = dataRequest.data.email ? dataRequest.data.email : false;

                    //check email
                    if (check_email) {
                      bsLib.ajax(
                        'GET',
                        bsLib.railsHost() +
                          '/marketing_api/check_email_validation?email=' +
                          encodeURIComponent(check_email) +
                          '&source=paid_ads',
                        {},
                        true,
                        {
                          'content-type': 'application/x-www-form-urlencoded; charset=utf-8', // Setting content type.
                        },
                        function (data2) {
                          if (data2.readyState === 4) {
                            var dataRequest2 = bsLib.JSONParse(data2.response);

                            if (thatBtn) {
                              thatBtn.removeAttribute('disabled');
                              loaderIcon.classList.add('hide');
                              btnText.classList.remove('hide');
                            }

                            //remove disable
                            submitBtn = document.querySelector('#tingle-modal-box .demo-fc__submit');
                            if (submitBtn) {
                              submitBtn.removeAttribute('disabled');
                            }

                            //show email validation for public
                            var modalContainer = document.querySelector('.demo-fc');
                            if (modalContainer) {
                              demoFcModal = new tingle.modal({
                                focusAfterClosed: this,
                                cssClass: ['demo-fc-int'],
                                onClose: function () {
                                  WebEventTracker.logEvent(
                                    EDS.webEvents,
                                    'CsfInteractedWithCloseButton',
                                    bsLib.extend(
                                      {
                                        action: 'close',
                                      },
                                      popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
                                    )
                                  );
                                  //Close Event
                                  demoFcModal.destroy();
                                },
                              });

                              demoFcModal.setContent(modalContainer.innerHTML);
                              demoFcModal.open();
                            }

                            // public domain
                            if (dataRequest2.valid === false) {
                              //load event on form
                              WebEventTracker.logEvent(
                                EDS.webEvents,
                                'LoadContactForm',
                                bsLib.extend(
                                  {
                                    action: 'view',
                                  },
                                  popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
                                )
                              );

                              //show email validation
                              DemoFcIntegrationInit();

                              //add focus on email
                              var expEmailField = document.querySelector('#tingle-modal-box .demo-fc__email-input');
                              expEmailField ? expEmailField.focus() : null;
                            } else {
                              //show loader
                              showLoaderSuccess();
                            }
                          }
                        },
                        function () {}
                      );
                    }
                  }
                }
              },
              function () {
                return 'user details not rendered';
              },
              false,
              true //withCredentials
            );
          }
        },
        false
      );
    }
  }

  function fcModalFormBtnValidation() {
    var emailField = document.querySelector('#tingle-modal-box .demo-fc__email-input'),
      emailError = document.querySelector('#tingle-modal-box .error-email-span'),
      emailNotifyMsg = document.querySelector('#tingle-modal-box .email-notify-msg'),
      submitBtn = document.querySelector('#tingle-modal-box .demo-fc__submit'),
      validEmailBool = true;

    if (emailField) {
      if (emailError) {
        emailError.remove();
      }
      emailField.classList.remove('error-border');
      emailNotifyMsg.classList.remove('hide');

      if (emailField.value.trim().length == 0 || !bsLib.validEmail(emailField.value.trim())) {
        validEmailBool = false;
        emailField.classList.add('error-border');
        emailNotifyMsg.classList.add('hide');
        emailValidationMsg(emailField);
      }

      if (validEmailBool) {
        //disabled
        submitBtn.setAttribute('disabled', 'disabled');

        bsLib.ajax(
          'GET',
          bsLib.railsHost() +
            '/marketing_api/check_email_validation?email=' +
            encodeURIComponent(emailField.value) +
            '&source=paid_ads',
          {},
          true,
          {
            'content-type': 'application/x-www-form-urlencoded; charset=utf-8', // Setting content type.
          },
          function (data) {
            if (data.readyState === 4) {
              var dataRequest = bsLib.JSONParse(data.response);

              //remove disable
              submitBtn = document.querySelector('#tingle-modal-box .demo-fc__submit');
              if (submitBtn) {
                submitBtn.removeAttribute('disabled');
              }

              if (dataRequest.valid === false) {
                emailField.dataset.notvalid = '1';
                emailField.classList.add('error-border');
                emailNotifyMsg.classList.add('hide');
                if (emailField.parentNode.getElementsByClassName('error-email-span').length === 0) {
                  emailValidationMsg(emailField);
                }
              } else {
                //Send EDS event to pii table only EDS event because passing email
                //Not send to amplitude
                if (EDS.hasOwnProperty('logEvent')) {
                  EDS.logEvent(
                    'clickGetDemo',
                    EDS.webEventsPii,
                    bsLib.extend(
                      {
                        email: emailField.value,
                        user_id: Cookie.read(stage_env_cookie_prefix + 'bs_logging_id'),
                      },
                      popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
                    )
                  );
                }

                //show loader success
                showLoaderSuccess();
              }
            }
          },
          function () {}
        );
      }
    }
  }

  function showLoaderSuccess() {
    FreshChatConfig.chatBubble.visible = false;

    var mainWrap = document.querySelector('.demo-fc-int');
    mainWrap.querySelector('.demo-fc__container').classList.add('hide');
    mainWrap.querySelector('.demo-fc__container-success').classList.remove('hide');
    mainWrap.querySelector('.tingle-modal__close').classList.add('hide');

    //View Event
    WebEventTracker.logEvent(
      EDS.webEvents,
      'DemoExCorporateLoaderDisplay',
      bsLib.extend(
        {
          action: 'click',
        },
        popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
      )
    );

    //freshchat file
    if (typeof window.fcWidget === 'undefined') {
      freshChat.show();
    } else {
      window.fcWidget.destroy();
      freshChat.initFreshChat();
    }

    FreshChatConfig.tags = ["demo_chat_experiment"];
    freshChat.setChannel('demo_chat_experiment');
    setTimeout(function () {
      var widgetTimeOut = true;
      if (window.fcWidget) {
        window.fcWidget.open();
        
        window.fcWidget.on('widget:opened', function () {
          mainWrap.querySelector('.tingle-modal-box').style.display = 'none'; //as per model code

          widgetTimeOut = false;

          //hide custom frame
          var fc1 = document.getElementById('custom-fc-frame'); //variable cache issue to define again
          if (fc1) {
            fc1.classList.add('hide');
          }
        });

        window.fcWidget.on('widget:closed', function (resp) {
          //Close Event
          demoFcModal.destroy();

          //destroy fc
          window.fcWidget.destroy();

          //hide custom frame
          var fc1 = document.getElementById('custom-fc-frame'); //variable cache issue to define again
          if (fc1) {
            fc1.classList.add('hide');
          }

          //update cookie
          Cookie.create(stage_env_cookie_prefix + 'bs_freshchat_open_status', '0', 1);
        });

        window.fcWidget.on('message:sent', function (resp) {
          //create freshchat cookie
          Cookie.create(stage_env_cookie_prefix + 'show_freshchat', '1', 30);
        });

        //Timeout error after 20 sec
        setTimeout(function () {
          if (widgetTimeOut) {
            //Show alert
            new bsAlert({
              alertType: "error",
              timeout: 4000,
              htmlMessage: true,
              text: Messages.salesAndSupportPage.longRequest
            });
          
            //View Event
            WebEventTracker.logEvent(
              EDS.webEvents,
              'FreshChat',
              bsLib.extend(
                {
                  errormsg: 'Request is taking too long. Please try again later',
                },
                popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
              )
            );

            //freshchat close
            window.fcWidget.close();

            //Close modal
            demoFcModal.destroy();
          }
        }, 20000);
      }
    }, 3000);
  }

  function emailValidationMsg(emailEle) {
    emailEle.insertAdjacentHTML(
      'afterend',
      '<span class="error-email-span" id="error-email-span"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00016 1.33333C4.32016 1.33333 1.3335 4.31999 1.3335 8C1.3335 11.68 4.32016 14.6667 8.00016 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8C14.6668 4.31999 11.6802 1.33333 8.00016 1.33333ZM8.66683 11.3333H7.3335V10H8.66683V11.3333ZM8.66683 8.66666H7.3335V4.66666H8.66683V8.66666Z" fill="#AE2727"/></svg><span class="error-message" id="email-error">' +
        (emailEle.value.trim().length == 0
          ? Messages.salesAndSupportPage.noemail
          : 'Please share valid Business Email') +
        '</span></span>'
    );
  }

  function DemoFcIntegrationInit() {
    var emailField = document.querySelector('#tingle-modal-box .demo-fc__email-input');

    if (emailField) {
      emailField.addEventListener('blur', function (event) {
        event.preventDefault();
        var that = this,
        emailError = document.querySelector('#tingle-modal-box .error-email-span'),
        emailNotifyMsg = document.querySelector('#tingle-modal-box .email-notify-msg');

        that.dataset.notvalid = '0';

        if (emailError) {
          emailError.remove();
        }
        that.classList.remove('error-border');
        emailNotifyMsg.classList.remove('hide');

        WebEventTracker.logEvent(
          EDS.webEvents,
          'InteractedWithSalesForm',
          bsLib.extend(
            {
              action: 'click',
            },
            popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
          )
        );

        if (that.value.trim().length == 0 || !bsLib.validEmail(that.value.trim())) {
          that.classList.add('error-border');
          emailNotifyMsg.classList.add('hide');
          emailValidationMsg(that);
        }
      });

      emailField.addEventListener('focus', function (event) {
        WebEventTracker.logEvent(
          EDS.webEvents,
          'CsfInteractedWithEmailField',
          bsLib.extend(
            {
              action: 'click',
            },
            popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
          )
        );
      });
    }

    var submitForm = document.querySelector('#tingle-modal-box #demo-fc');
    if (submitForm) {
      submitForm.addEventListener('submit', function (event) {
        event.preventDefault();
        //View Event
        WebEventTracker.logEvent(
          EDS.webEvents,
          'SubmitContactForm',
          bsLib.extend(
            {
              field: 'submit',
              action: 'click',
            },
            popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
          )
        );
        fcModalFormBtnValidation();

        return false;
      });
    }
  }
})();

demoFcIntegration.init();
